// Menu links
export const links = [
  {
    id: 1,
    text: 'Home',
    url: '/',
  },
  {
    id: 2,
    text: 'About Us',
    url: '/about',
    subLinks: [
      {
        id: 99,
        text: 'About Solaric',
        url: '/about/aboutSolaric',
      },
      {
        id: 311,
        text: 'The Team',
        url: '/about/theTeam',
      },
      {
        id: 312,
        text: 'Innovations',
        url: '/about/innovations',
      },
      {
        id: 313,
        text: 'Milestones',
        url: '/about/milestones',
      },
    ],
  },
  {
    id: 3,
    text: 'Solution',
    url: '/solutions',
    subLinks: [
      {
        id: 77,
        text: 'CAPEX',
        url: '/solutions/capex',
      },
      {
        id: 88,
        text: 'OPEX',
        url: '/solutions/opex',
      },
      {
        id: 989,
        text: 'Comparison',
        url: '/solutions/comparison',
      },
    ],
  },
  {
    id: 4,
    text: 'Projects',
    url: '/projects',
    subLinks: [
      {
        id: 11,
        text: 'All Projects',
        url: '/projects#all',
      },
      {
        id: 22,
        text: 'Completed  Projects',
        url: '/projects/completed',
      },
      {
        id: 33,
        text: 'Ongoing projects',
        url: '/projects/ongoing',
      },
    ],
  },
  {
    id: 5,
    text: 'Blog/News',
    url: '/blog',
  },
  {
    id: 6,
    text: 'Contact',
    url: '/contact',
  },
  {
    id: 7,
    text: 'Downloads',
    url: '/downloads',
  },
];
